import { call, put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { removeCommentFail, removeCommentLoad, removeCommentSuccess, toxicLoad } from '../slices/common.slice';
import { removeCommentApi, toxicApi } from '../Api/api';

function* removeCommentSaga(action) {
    try {
        const response = yield call(removeCommentApi, { comment: action.payload.commentId });
        if (response?.status == 0) {
            toast.success(response?.result?.message)
            yield put(removeCommentSuccess(action.payload.commentId));
        }
        else {
            toast.error(response?.result?.message)
            yield put(removeCommentFail());
        }
    } catch (error) {
        toast.error(error)
        yield put(removeCommentFail());
    }
}

function* commonSaga() {
    yield takeLatest(removeCommentLoad.type, removeCommentSaga);
}

export default commonSaga;